'use strict';

// Needed for Safari & IE
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

// These will self-invoke if required
import 'url-polyfill';
import 'url-search-params-polyfill';
import 'whatwg-fetch';
import 'promise-polyfill/src/polyfill';
import 'formdata-polyfill';

// our polyfills will self-invoke if required
import 'utils/polyfills';

// widgets will invoke themselves
// vue widgets?

// Slide Up, Slide Down
import 'dom-slider';


import {init as accordion} from 'modules/accordion';
import {init as categorySwitch} from 'modules/category-switch';
import {init as dialog} from 'modules/dialog';
import {init as donate} from 'modules/donate';
import forms from 'modules/forms';
import {init as eventHeaderNav} from 'modules/event-header-nav';
import {init as eventHeaderScroll} from 'modules/event-header-scroll';
import {init as eventInstances} from 'modules/event-instances';
import {init as eventNav} from 'modules/event-nav';
import {init as globalHeader} from 'modules/global-header';
import {init as globalNavigation} from 'modules/global-navigation';
import {init as globalNavigationScroll} from 'modules/global-navigation-scroll';
import {init as headerVideo} from 'modules/header-video';
import {init as imageGallery} from 'modules/image-gallery';
import {init as infiniteScroll} from 'modules/infinite-scroll';
import {init as linkableSelect} from 'modules/linkable-select';
import {init as membershipLevels} from 'modules/membership-levels';
import {init as menuTabindex} from 'modules/menu-tabindex';
import {init as messages} from 'modules/messages';
import {init as scroller} from 'modules/scroller';
import {init as tabbing} from 'modules/tabbing';
import {init as toggle} from 'modules/toggle';
import {init as userStatus} from 'modules/user-status';
import {init as validation} from 'modules/validation';
import {init as videoModal} from 'modules/video-modal';
import {init as videoResize} from 'modules/video-resize';
import {init as youtube} from 'modules/youtube';

// Vue widgets
import './widgets/bootstrap';

// To make sure the code is run AFTER VueJS is loaded
// Code in imported modules is run asynchronously so cannot control the order but will ALWAYS run before the file doing the import
window.addEventListener('load', function () {
    accordion();
    categorySwitch();
    dialog();
    donate();
    forms();
    eventHeaderNav();
    eventHeaderScroll();
    eventInstances();
    globalHeader();
    globalNavigation();
    globalNavigationScroll();
    headerVideo();
    imageGallery();
    infiniteScroll();
    linkableSelect();
    membershipLevels();
    menuTabindex();
    messages();
    scroller();
    eventNav();
    tabbing();
    toggle();
    validation();
    videoModal();
    videoResize();
    youtube();

    // breaks patterns so will put to bottom for now
    userStatus();
});
